





import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({})
export default class DeviceType extends Vue {
  @Prop()
  row!: any

  @Prop({ default: 'is-small' }) size?: string
}
